// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__zq+n9","normalXl":"styles_normalXl__64IIn","normalLg":"styles_normalLg__7mleL","normalMd":"styles_normalMd__KUBL-","normalSm":"styles_normalSm__klpJk"};